<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<span v-if="obrigatorio" class="no-print">*</span> {{ label }}:
		</label>
		<date-picker
			v-if="!_isMobile"
			class="datepicker-input form-control-datepicker"
			v-model="value"
			format="HH:mm"
			type="time"
			value-type="HH:mm"
			@input="$emit('input', $event)"
			:disabled="disabled"
			input-class="class-input"
		></date-picker>
		<template v-else>
			<date-picker
				ref="datepicker"
				class="datepicker-input form-control-datepicker"
				v-model="value"
				format="HH:mm"
				type="time"
				value-type="HH:mm"
				@input="$emit('input', $event)"
				:disabled="disabled"
				input-class="class-input"
				:append-to-body="false"
				@open="$refs.modalTime.modalShow(30)"
				@close="$refs.modalTime.modalHide()"
				:popup-style="{
					position: 'relative',
					top: '0px',
					left: '0px'
				}"
				popup-class="teste"
				:confirm="true"
			></date-picker>
			<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
			<modal ref="modalTime" transparent>
				<Row>
					<Column>
						<div
							ref="target"
							style="
								position: relative;
								display: flex;
								align-items: center;
								justify-content: center;
							"
						></div
					></Column>
				</Row>
			</modal>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		value: {
			type: String,
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if (this.$refs.datepicker && this.$refs.target) {
			const el = this.$refs.datepicker.$refs.popup.$el
			this.$refs.target.appendChild(el)
		}
	}
}
</script>

<style scoped>
.class-input {
	font-size: 11px !important;
}
</style>